import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useRouteMatch } from 'react-router';

import LoadingIndicator from '@swf/components/LoadingIndicator/LoadingIndicator';

import useGetCurrentClub from '../../../../hooks/useGetCurrentClub';
import type { UserClubRole } from '../../../../types/common';
import useCloseOrLeaveClub from '../../Settings/hooks/useCloseOrLeaveClub';

import { TXTWCL_Leave_Club } from './LeaveClubButton.messages.json';
import styles from './LeaveClubButton.scss';

const LeaveClubButton: React.FC = () => {
  const {
    params: { clubId }
  } = useRouteMatch<{ clubId: string }>();
  const club = useGetCurrentClub(clubId);
  const roleForUser = club?.roleForUser;
  const { action, loading: leaveClubLoading } = useCloseOrLeaveClub();

  return (
    <div onClick={() => action(roleForUser as UserClubRole)} role="button">
      {leaveClubLoading ? (
        <LoadingIndicator className={styles.loading} loading={leaveClubLoading} />
      ) : (
        <Translation {...TXTWCL_Leave_Club} />
      )}
    </div>
  );
};

export default LeaveClubButton;
